import { gql } from '@apollo/client';

export const addRecentAccount = gql`
  mutation addRecentAccount($oid: UUID!, $type: RecentAccountType!) {
    addRecentAccount(input: { oid: $oid, type: $type })
  }
`;
